import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function putActivateDatamaster(datamasterId) {
  let results = ''
  try {
    results = await axios.put(`${DATAMASTER_ENDPOINT}/${datamasterId}`, { curated: true })
  } catch (error) {
    results = error.message
  }
  return results
}
